import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`apple-navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="apple-nav-container">
        <Link to="/" className="apple-logo" onClick={closeMobileMenu}>
          <img 
            src="/logo/logo_in_White-1.webp" 
            alt="Dvi Studios" 
            className="apple-logo-img"
          />
          <span className="apple-logo-text">Dvi Studio's</span>
        </Link>
        
        <ul className={`apple-nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
          <li>
            <Link 
              to="/" 
              className={location.pathname === '/' ? 'active' : ''}
              onClick={closeMobileMenu}
            >
              Home
            </Link>
          </li>
          <li>
            <Link 
              to="/about" 
              className={location.pathname === '/about' ? 'active' : ''}
              onClick={closeMobileMenu}
            >
              About
            </Link>
          </li>
          <li>
            <Link 
              to="/portfolio" 
              className={location.pathname === '/portfolio' ? 'active' : ''}
              onClick={closeMobileMenu}
            >
              Portfolio
            </Link>
          </li>
          <li>
            <Link 
              to="/photo-videography" 
              className={location.pathname === '/photo-videography' ? 'active' : ''}
              onClick={closeMobileMenu}
            >
              Photo & Video
            </Link>
          </li>
          <li>
            <Link 
              to="/pre-post-wedding" 
              className={location.pathname === '/pre-post-wedding' ? 'active' : ''}
              onClick={closeMobileMenu}
            >
              Pre & Post Wedding
            </Link>
          </li>
          <li>
            <Link 
              to="/fashion-shoot" 
              className={location.pathname === '/fashion-shoot' ? 'active' : ''}
              onClick={closeMobileMenu}
            >
              Fashion Shoots
            </Link>
          </li>
          <li>
            <Link 
              to="/corporate-events" 
              className={location.pathname === '/corporate-events' ? 'active' : ''}
              onClick={closeMobileMenu}
            >
              Corporate Events
            </Link>
          </li>
          <li>
            <Link 
              to="/baby-shoots" 
              className={location.pathname === '/baby-shoots' ? 'active' : ''}
              onClick={closeMobileMenu}
            >
              Baby Shoots
            </Link>
          </li>
          <li>
            <Link 
              to="/ads" 
              className={location.pathname === '/ads' ? 'active' : ''}
              onClick={closeMobileMenu}
            >
              Advertising
            </Link>
          </li>
          <li>
            <Link 
              to="/podcast" 
              className={location.pathname === '/podcast' ? 'active' : ''}
              onClick={closeMobileMenu}
            >
              Podcast
            </Link>
          </li>
          <li>
            <Link 
              to="/film-making" 
              className={location.pathname === '/film-making' ? 'active' : ''}
              onClick={closeMobileMenu}
            >
              Film Making
            </Link>
          </li>
          <li>
            <Link 
              to="/contact" 
              className={location.pathname === '/contact' ? 'active' : ''}
              onClick={closeMobileMenu}
            >
              Contact
            </Link>
          </li>
        </ul>
        
        <button 
          className={`apple-mobile-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className="apple-hamburger-line"></span>
          <span className="apple-hamburger-line"></span>
          <span className="apple-hamburger-line"></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
